import { ConfigProvider } from 'antd';
import React, { type PropsWithChildren } from 'react';

import EmptyContentBox from '../EmptyContentBox/EmptyContentBox';
import {
  BasicVariantContainer,
  FlatVariantContainer,
} from './TableWrapper.styles';

export type TableVariant = 'basic' | 'flat';

export type TableWrapperProps = PropsWithChildren<{
  className?: string;
  isLoading?: boolean;
  loadingLabel?: string;
  noDataLabel?: string;
  variant?: TableVariant;
}>;

function TableWrapper(props: TableWrapperProps) {
  const { children, className, variant, ...emptyBoxProps } = props;

  // 'flat' only ever used by MembersTable
  const Container =
    variant === 'flat' ? FlatVariantContainer : BasicVariantContainer;

  return (
    <ConfigProvider renderEmpty={() => <EmptyContentBox {...emptyBoxProps} />}>
      <Container className={className}>{children}</Container>
    </ConfigProvider>
  );
}

export default TableWrapper;
